import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";

// Einstellungen für den automatischen Kundendatei-Import (Website-Anbindung).
export const FileImportSettings = ({ isAdmin }) => {
  const [s, setS] = useState(null);
  const [pw, setPw] = useState("");
  useEffect(() => { api.get("/integrationen/datei-import").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return null;
  const set = (k) => (e) => setS({ ...s, [k]: e?.target ? e.target.value : e });
  const save = async () => {
    try {
      const r = await api.put("/integrationen/datei-import", { ...s, nextcloud_password: pw || undefined });
      setS(r.data); setPw(""); toast.success("Datei-Import-Einstellungen gespeichert.");
    } catch (e) { toast.error(e?.response?.data?.detail || "Speichern fehlgeschlagen."); }
  };
  return (
    <div className="border-t border-slate-100 pt-4 space-y-3" data-testid="file-import-settings">
      <div className="text-sm font-medium">Kundendatei-Import</div>
      <p className="text-xs text-slate-500">Dateien aus der Nextcloud-Freigabe des Plugins werden automatisch in die Dateiablage des Auftrags übernommen.</p>
      <div>
        <Label>Erlaubte Datei-Hosts</Label>
        <Input value={s.allowed_hosts} onChange={set("allowed_hosts")} placeholder="z. B. cloud.druckexperten.com (leer = jeder öffentliche Host)" disabled={!isAdmin} data-testid="file-import-hosts-input" />
      </div>
      <label className="flex items-center justify-between gap-4 text-sm">
        <span>Unverschlüsselte http-Links erlauben<span className="block text-xs text-slate-500">Nicht empfohlen – standardmäßig nur https.</span></span>
        <Switch checked={s.allow_http} onCheckedChange={set("allow_http")} disabled={!isAdmin} data-testid="file-import-http-switch" />
      </label>
      <details className="border border-slate-200 rounded-md p-3 text-sm" data-testid="file-import-nextcloud-fallback">
        <summary className="cursor-pointer text-slate-600">Optional: Nextcloud-Zugang als Fallback</summary>
        <p className="text-xs text-slate-500 mt-2">Nur nötig, wenn der öffentliche Freigabe-Link nicht funktioniert. Es wird per WebDAV im Ordner „{s.nextcloud_root}/&lt;Referenz&gt;“ gesucht.</p>
        <div className="grid sm:grid-cols-2 gap-3 mt-3">
          <div><Label>Nextcloud-URL</Label><Input value={s.nextcloud_url} onChange={set("nextcloud_url")} placeholder="https://cloud.example.de" disabled={!isAdmin} data-testid="nextcloud-url-input" /></div>
          <div><Label>Nextcloud-Benutzer</Label><Input value={s.nextcloud_user} onChange={set("nextcloud_user")} disabled={!isAdmin} data-testid="nextcloud-user-input" /></div>
          <div><Label>Nextcloud-App-Passwort</Label><Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder={s.nextcloud_password_set ? "•••••••• (gespeichert)" : ""} disabled={!isAdmin} data-testid="nextcloud-password-input" /></div>
          <div><Label>Stammordner</Label><Input value={s.nextcloud_root} onChange={set("nextcloud_root")} disabled={!isAdmin} data-testid="nextcloud-root-input" /></div>
        </div>
      </details>
      {isAdmin && <Button size="sm" onClick={save} data-testid="file-import-save-button">Datei-Import speichern</Button>}
    </div>
  );
};
